import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class depotSelectCtrl implements IController {

  selectedId: any;
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  branchIds: string[];
  accountIds: string[];
  isHideLabel: boolean;
  onChange: Function;

  private depotsRef: any;
  public selectedDepot: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $depots, private $element) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    this._setSelectedDepot();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange()) ||
      (changes.accountIds && !changes.accountIds.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange())) {
      this._setSelectedDepot();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const branchIdsRef = this.branchIds;
    const accountIdsRef = this.accountIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'account-ids="ctrl.accountIdsRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'depot';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.branchIdsRef = branchIdsRef;
        this.accountIdsRef = accountIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({depot: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const depot = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({depot: depot, id: selectedId});
            panel.destroy();
          } else {
            this.depotsRef.$asyncValues([selectedId])
              .then((depots) => {
                this.onChange({depot: depots[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({depot: undefined});
  }

  private _setSelectedDepot() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedDepot = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.depotsRef.$asyncValues([this.selectedId])
          .then((depots) => {
            this.selectedDepot = _.orderBy(depots, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedDepot = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedDepot, 'name', '');
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      branchIds: '<?',
      accountIds: '<?',
      isHideLabel: '<?',
      onChange: '&'
    },
    template: require('./depot-select.html').default,
    controller: depotSelectCtrl
  });
